import { LetterT } from 'tabler-icons-react';
import {
  ECOM_WEBSTORE_SECTION_BLOCK_TYPE_ENUM,
  INPUT_CONTROL_TYPE_ENUM
} from '../../../../../config/constants';
import WsTitleBlock from './WsTitleBlock';

const configNameValues = {
  titleSize: 'titleSize',
  titleMobileSize: 'titleMobileSize'
};

const configDefaultValues = {
  titleSize: '28',
  titleMobileSize: '20'
};

const configOptions = {
  [configNameValues.titleSize]: {
    label: 'Desktop title size',
    type: INPUT_CONTROL_TYPE_ENUM.SLIDER,
    min: 18,
    max: 32
  },
  [configNameValues.titleMobileSize]: {
    label: 'Mobile title size',
    type: INPUT_CONTROL_TYPE_ENUM.SLIDER,
    min: 18,
    max: 32
  }
};

const config = {
  title: 'Title',
  type: ECOM_WEBSTORE_SECTION_BLOCK_TYPE_ENUM.TITLE,
  icon: LetterT,
  Component: WsTitleBlock,
  configOptions,
  defaultConfig: configDefaultValues,
  getTitle: (c) => c.text,
  displayFunctions: {getTitleValue: (ecomStoreProduct) => ecomStoreProduct.ecomVendorProduct.name}
};

export { config, configOptions, configNameValues, configDefaultValues };
